import server from './server.store'
import anonymous from './anonymous.store'
import auth from './auth.store'
import event from './event.store'
import tableau from './tableau.store'

import v1 from './v1'

export default {
    server,
    anonymous,
    auth,
    tableau,
    event,
    v1: {
        namespaced: true,
        modules: {
            ...v1
        }
    },
}